interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showText?: boolean;
  text?: string;
}

export const Loader = ({ size = 'md', className = '', showText = false, text = 'Loading...' }: LoaderProps) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      <div className={`relative ${sizeClasses[size]}`}>
        <div className="absolute inset-0 rounded-full border-4 border-solid border-gray-200"></div>
        <div className="absolute inset-0 rounded-full animate-spin border-4 border-solid border-blue-500 border-t-transparent"></div>
      </div>
      {showText && (
        <p className="text-sm text-gray-500">{text}</p>
      )}
    </div>
  );
}; 